import { Column, LoadingWarren } from '@simplywallst/ui-core';
import { LoadingOverlayWrapper, LoadingTextWrapper } from './styled';

export interface LoadingOverlayProps {
  loadingText?: string;
}

const LoadingOverlay = ({ loadingText }: LoadingOverlayProps) => (
  <LoadingOverlayWrapper>
    <Column
      justifyContent="center"
      alignItem="center"
      alignContent="center"
      displayFlex
      column
    >
      <LoadingWarren />
      {loadingText && <LoadingTextWrapper>{loadingText}</LoadingTextWrapper>}
    </Column>
  </LoadingOverlayWrapper>
);

export default LoadingOverlay;
